<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-' + item.ID">
                <td>
                  <v-edit-dialog :return-value.sync="item.ChinaStoreID" large lazy persistent @save="saveItem({'ID': item.ID, 'ChinaStoreID': item.ChinaStoreID })">
                    <div>{{ chinaStoreDisplay(item.ChinaStoreID) }}</div>
                    <template v-slot:input>
                        <v-select :items="chinaStores" v-model="item.ChinaStoreID" item-text="Name" item-value="ID"></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog :return-value.sync="item.ReceivePlaceID" large lazy persistent @save="saveItem({'ID': item.ID, 'ReceivePlaceID': item.ReceivePlaceID })">
                    <div>{{ storeDisplay(item.ReceivePlaceID) }}</div>
                    <template v-slot:input>
                        <v-select :items="stores" v-model="item.ReceivePlaceID" item-text="Name" item-value="ID"></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog :return-value.sync="item.ProductType" large lazy persistent @save="saveItem({'ID': item.ID, 'ProductType': item.ProductType })">
                    <div>{{ item.ProductType | display_value(orderTypes) }}</div>
                    <template v-slot:input>
                        <v-select :items="orderTypes" v-model="item.ProductType" item-text="name" item-value="value"></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog :return-value.sync="item.FeeObject" large lazy persistent @save="saveItem({'ID': item.ID, 'FeeObject': item.FeeObject })">
                    <div>{{ item.FeeObject }}</div>
                    <template v-slot:input>
                        <v-textarea rows="5" v-model="item.FeeObject" @focus="true"></v-textarea>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  {{ (item.ModifiedDate || item.CreatedDate) | display_date }}
                </td>
                <td>{{ item.ModifiedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="copyDetail(item)">fa-copy</v-icon>
                  <v-icon medium @click="deleteItem(item.ID)"
                    >fa-trash-alt</v-icon
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  props: ["priceId"],
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Kho TQ",
          value: "ChinaStoreID",
          filterable: true,
          values: [],
          dataType: dataType["Enum"],
        },
        {
          text: "Kho VN",
          value: "ReceivePlaceID",
          filterable: true,
          values: [],
          dataType: dataType["Enum"],
        },
        {
          text: "Loại đơn",
          value: "ProductType",
          filterable: true,
          values: configs.ORDER_TYPE_LIST,
          dataType: dataType["Enum"],
        },
        {
          text: "Cài đặt phí",
          value: "FeeObject",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Ngày sửa",
          value: "ModifiedDate",
          filterable: true,
          dataType: dataType["Date"],
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      orderTypes: configs.ORDER_TYPE_LIST,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "feeVolume_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    },
    chinaStores() {
      let header_item = _.find(this.headers, { value: "ChinaStoreID" });
      if (header_item) {
        header_item.values =
          _.map(this.chinaStores, (item) => {
            return {
              value: item.ID,
              name: item.Name,
            };
          }) || [];
      }
    },
    stores() {
      let header_item = _.find(this.headers, { value: "ReceivePlaceID" });
      if (header_item) {
        header_item.values =
          _.map(this.stores, (item) => {
            return {
              value: item.ID,
              name: item.Name,
            };
          }) || [];
      }
    },
  },
  computed: mapState({
    items: (state) => state.feeVolume.all.data,
    total_rows: (state) => state.feeVolume.all.total,
    loading: (state) => state.feeVolume.loading,
    currentFeeWeight: (state) => state.feeVolume.selected,
    stores: (state) => state.commons.stores,
    chinaStores: (state) => state.commons.chinaStores,
  }),
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      if (this.priceId) {
        param.filter.push({
          column: "PriceID",
          value: this.priceId,
          condition: "equal",
        });
      }
      this.$store.dispatch("feeVolume/getList", param);
    },
    gotoDetail: function (id) {
      let routeData = this.$router.resolve({
        name: "FeeVolumeDetail",
        params: {
          Pid: id,
          title: `Chi tiết phí khối (#${id})`,
        },
      });
      window.open(routeData.href, "_blank");
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", {'id': id, 'viewName': this.viewName});
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$router.push({
        name: "FeeVolumeDetail",
        params: {
          Pid: "tao-moi",
          title: `Tạo mới phí khối`,
        },
      });
    },
    storeDisplay(value) {
      const store = _.find(this.stores, { ID: value });
      return store ? store.Name : "";
    },
    chinaStoreDisplay(value) {
      const store = _.find(this.chinaStores, { ID: value });
      return store ? store.Name : "";
    },
    saveItem(obj) {
      this.$store.dispatch("feeVolume/setDetail", {data: obj, id: obj.ID});
    },
    copyDetail: function (item) {
      this.$store.dispatch("feeVolume/setDetail", {data: item});
    },
  },
  mounted() {
    this.$store.dispatch("commons/getAllStores");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", item => {
      if(item.viewName == this.viewName) {
        this.$store.dispatch("feeVolume/removeDetail", item.id);
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>
